<template>
  <div>
    <h1 v-bg-typography="'h1'" :style="{ marginTop: '10px' }">Questionnaire</h1>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";

export default {
  directives: {
    BgTypography,
  },
  data() {
    return {};
  },
};
</script>
